<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update transporter truck</small>
      </legend>
      <div>
        <form @submit.prevent="truckUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="transporter_id" :value="Truck.transporter_id" />
              <input type="hidden" class="id" :value="Truck.id" />
              <div class="form-group">
                <label>Truck no</label>
                <input
                  type="text"
                  class="form-control truck_no input-rounded f-s-14"
                  :value="Truck.truck_no"
                  placeholder="truck number plate"
                  required
                />
              </div>
              <div class="form-group">
                <label>Driver name</label>
                <input
                  type="text"
                  class="form-control driver_name input-rounded f-s-14"
                  :value="Truck.driver_name"
                  placeholder="driver name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Driver phone</label>
                <input
                  type="text"
                  class="form-control driver_phone input-rounded f-s-14"
                  :value="Truck.driver_phone"
                  placeholder="driver phone number"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Trailer no</label>
                <input
                  type="text"
                  class="form-control trailer_no input-rounded f-s-14"
                  :value="Truck.trailer_no"
                  placeholder="trailer number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Driver Id number</label>
                <input
                  type="number"
                  class="form-control driver_id_number input-rounded f-s-14"
                  :value="Truck.driver_id_number"
                  placeholder="driver id number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Dl licence no</label>
                <input
                  type="text"
                  class="form-control dl_licence input-rounded f-s-14"
                  :value="Truck.dl_licence"
                  placeholder="driving licence number"
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingTruck btn-rounded">
            <i class="fa fa-refresh"></i> update transporter truck
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingTruckLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import $ from "jquery";
export default {
  created() {
    if (this.$store.getters.Truck.length === 0) {
      router.push("/managetrucks");
    }
  },
  computed: {
    ...mapGetters(["Truck"])
  },
  methods: {
    ...mapActions(["truckUpdate"])
  }
};
</script>
<style scoped>
.updatingTruckLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/updatetruck.vue